<div class="rs-flex rs-flex-dir-col rs-maxh">
  <h3 class="rs-tit6">{{ 'cloud.download.title' | translate }}</h3>
  <div class="rs-flex-row">
    <div class="rs-flex-column rs-flex-shrink">
      <a
        href="{{ 'cloud.download.android.link' | translate }}"
        target="_blank"
        data-tms-event="link-click"
        attr.data-tms-link-zone="{{ 'cloud.download.title' | translate }}"
        data-tms-link-name="download android"
        attr.data-tms-link-url="{{ 'cloud.download.android.link' | translate }}"
      >
        <img
          class="rs-h-s4"
          alt="Download for Google Play"
          src="{{ 'cloud.download.android.image.path' | translate }}"
        />
      </a>
    </div>
    <div class="rs-flex-column">
      <a
        href="{{ 'cloud.download.ios.link' | translate }}"
        target="_blank"
        data-tms-event="link-click"
        attr.data-tms-link-zone="{{ 'cloud.download.title' | translate }}"
        data-tms-link-name="download ios"
        attr.data-tms-link-url="{{ 'cloud.download.ios.link' | translate }}"
      >
        <img
          class="rs-h-s4"
          alt="Download for App Store"
          src="{{ 'cloud.download.ios.image.path' | translate }}"
        />
      </a>
    </div>
  </div>
  <div class="rs-me"></div>
  <div class="rs-flex-grow rs-flex rs-flex-bottom">
    <p>
      <button
        class="rs-btn-no-style rs-link rs-txt-hover"
        (click)="click()"
        aria-controls="ac-downloadPanel"
      >
        {{ 'cloud.download.alsoForDesktop' | translate }}
      </button>
    </p>
  </div>
</div>
